import { createFileRoute } from "@tanstack/react-router";
import { legacyPostRoute } from "@/features/legacy-operations";

export const Route = createFileRoute("/api/internal/email/messages/list")({
    ...legacyPostRoute,
});
